export type BannerId = string
export type Banner = {
  id: BannerId
  variant: BannerVariant
  title: string
  description: string | Array<string>
  showClose?: boolean
  linkText?: string
  url?: string
}
export const bannerVariants = {
  neutral: 'neutral',
  danger: 'danger',
  info: 'info',
  success: 'success',
  warning: 'warning',
} as const
export type BannerVariant = typeof bannerVariants[keyof typeof bannerVariants]
